module.exports = __webpack_public_path__ + "img/team-map-03.283f0c31.png";